var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSortDescending(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.60518 9H13.3951C13.7302 8.9989 14.0012 8.70261 14.0002 8.33792C13.9991 8.16318 13.9351 7.99603 13.8202 7.87338L10.4311 4.1951C10.1952 3.93678 9.81014 3.93462 9.5721 4.19075L9.56917 4.1951L6.18013 7.87338C5.94112 8.12954 5.94014 8.54739 6.1761 8.80572C6.28914 8.92944 6.44417 9 6.60518 9Z",
    fill: "#A2A1AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.395 11H6.60511C6.27003 11.0011 5.99903 11.2974 6.00001 11.6621C6.00111 11.8368 6.06507 12.004 6.18006 12.1266L9.5691 15.8049C9.80506 16.0632 10.1901 16.0654 10.4281 15.8092L10.431 15.8049L13.8201 12.1266C14.0591 11.8705 14.0601 11.4526 13.8241 11.1943C13.7111 11.0706 13.556 11 13.395 11Z",
    fill: "#454260"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortDescending);
export default __webpack_public_path__ + "static/media/sort-descending.e4bdd72b31c3eddceac14dbdbfe34111.svg";
export { ForwardRef as ReactComponent };